import { render, staticRenderFns } from "./nutrition-info.vue?vue&type=template&id=15f871ba&scoped=true&"
import script from "./nutrition-info.vue?vue&type=script&lang=js&"
export * from "./nutrition-info.vue?vue&type=script&lang=js&"
import style0 from "./nutrition-info.vue?vue&type=style&index=0&id=15f871ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f871ba",
  null
  
)

export default component.exports